import { create } from 'zustand';
import type { WifiProfile } from '@/stores/useBlockWifiStore';

export type { WifiProfile };

export interface WifiFieldRef {
    setProfile: (profile: WifiProfile | null) => void;
    getProfile: () => WifiProfile | null;
}

interface BlockModalWifiState {
    fieldRef: WifiFieldRef | null;
    setFieldRef: (ref: WifiFieldRef | null) => void;
}

export const useBlockModalWifiStore = create<BlockModalWifiState>((set) => ({
    fieldRef: null,
    setFieldRef: (ref) => set({ fieldRef: ref }),
}));
